// Sipariş talep formu ortak hesapları (ekran, PDF ve kayıt aynı formülü kullanır)
import { unitLabel } from "@/lib/format";

export const r2 = (x) => Math.round(((Number(x) || 0) + 1e-9) * 100) / 100;
export const itemCost = (it) => r2((Number(it.list_price) || 0) * (1 - (Number(it.cost_discount) || 0) / 100));
export const lineTotal = (it) => r2((Number(it.qty) || 0) * itemCost(it));

export const formTotals = (items = []) => {
  let net = 0, kdv = 0, qty = 0, undefinedDiscount = 0;
  for (const it of items) {
    const lt = lineTotal(it);
    net += lt;
    kdv += r2(lt * (Number(it.kdv_rate ?? 20)) / 100);
    qty += Number(it.qty) || 0;
    if ((it.discount_source || "yok") === "yok") undefinedDiscount++;
  }
  return { net: r2(net), kdv: r2(kdv), total: r2(net + kdv), count: items.length, qty: r2(qty), undefinedDiscount };
};

export const DEFAULT_PDF_OPTS = { showBrand: true, showCodes: true, showNotes: true, showPrices: false, showBlankCols: true, showTermin: false };
export const DEFAULT_TITLE = "SİPARİŞ TALEP FORMU";
export const TITLE_PRESETS = ["SİPARİŞ TALEP FORMU", "FİYAT TALEP FORMU"];
export const formTitleFor = () => DEFAULT_TITLE;
export const DEFAULT_DELIVERY = (company) => `Teslimat adresi: ${company.address} · ${company.name}`;
export const UNITS = ["ADET", "METRE", "KİLO", "PAKET", "KUTU", "TOP", "RULO", "METRETÜL", "TAKIM", "ÇİFT"];
export const STATUS = {
  taslak: { label: "Taslak", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  gonderildi: { label: "Tedarikçiye Gönderildi", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  siparis_verildi: { label: "Sipariş Verildi", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  tamamlandi: { label: "Tamamlandı", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
};

// Ürün (stok) → form kalemi; pricing = /order-forms/resolve-costs çıktısı
export const itemFromProduct = (p, pricing, qty = 1) => ({
  key: `${p.id}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  product_id: p.id, name: p.name || "", brand: p.brand || pricing?.brand || "", code: p.code || pricing?.code || "",
  qty, unit: unitLabel(p.unit || pricing?.unit, "ADET"), note: "",
  list_price: pricing?.list_price ?? Number(p.price || 0), cost_discount: pricing?.cost_discount ?? 0,
  kdv_rate: pricing?.kdv_rate ?? (p.kdv_rate ?? 20), custom: false, discount_source: pricing?.discount_source || "yok",
  stock: pricing?.stock ?? p.quantity ?? 0,
});

export const customItem = (name = "", brand = "") => ({
  key: `c-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  product_id: "", name, brand, code: "", qty: 1, unit: "ADET", note: "",
  list_price: 0, cost_discount: 0, kdv_rate: 20, custom: true, discount_source: "yok", stock: null,
});
